import Select from "react-select";
import {
  DESCRIPTION_TEXTAREA_CLASS,
  FieldLabel,
  descriptionSelectStyles,
} from "./descriptionUi";
import KeyLocationPasswordField from "./KeyLocationPasswordField";
import type { KeyLocationCatalogItem } from "../../services/propertyKeyLocation";
import {
  isDigitalKeyLocation,
  isOthersKeyLocation,
} from "../../utils/keyLocationRules";

type Props = {
  catalog?: KeyLocationCatalogItem[];
  keyLocationId?: number | null;
  keyLocationNote: string;
  keyLocationPassword: string;
  onKeyLocationChange: (id: number | null) => void;
  onKeyLocationNoteChange: (value: string) => void;
  onKeyLocationPasswordChange: (value: string) => void;
  locationError?: string;
  noteError?: string;
  passwordError?: string;
  allowBlankPassword?: boolean;
};

export default function KeyLocationFields({
  catalog,
  keyLocationId,
  keyLocationNote,
  keyLocationPassword,
  onKeyLocationChange,
  onKeyLocationNoteChange,
  onKeyLocationPasswordChange,
  locationError,
  noteError,
  passwordError,
  allowBlankPassword = false,
}: Props) {
  const items = catalog ?? [];
  const options = items.map((item) => ({
    label: item.name,
    value: item.id,
  }));
  const selectedId = keyLocationId ?? null;
  const showNote = isOthersKeyLocation(items, selectedId);
  const showPassword = isDigitalKeyLocation(items, selectedId);

  return (
    <div className="min-w-0 space-y-4">
      <div className="min-w-0">
        <FieldLabel error={locationError || noteError || passwordError}>
          Localização da chave
        </FieldLabel>
        <Select
          value={
            selectedId != null
              ? options.find(
                  (option) => Number(option.value) === Number(selectedId)
                ) ?? null
              : null
          }
          options={options}
          placeholder={
            items.length === 0 ? "Carregando opções…" : "Selecione"
          }
          styles={descriptionSelectStyles}
          noOptionsMessage={() =>
            items.length === 0 ? "Carregando opções…" : "Nenhuma opção"
          }
          onChange={(option) => {
            const nextId =
              option?.value != null && Number.isFinite(Number(option.value))
                ? Number(option.value)
                : null;
            onKeyLocationChange(nextId);
            if (!isOthersKeyLocation(items, nextId)) {
              onKeyLocationNoteChange("");
            }
            if (!isDigitalKeyLocation(items, nextId)) {
              onKeyLocationPasswordChange("");
            }
          }}
        />
      </div>
      {showNote ? (
        <div className="min-w-0">
          <FieldLabel error={noteError}>
            Observação da chave (obrigatória)
          </FieldLabel>
          <textarea
            className={`${DESCRIPTION_TEXTAREA_CLASS} min-h-[72px]`}
            value={keyLocationNote}
            onChange={(event) => onKeyLocationNoteChange(event.target.value)}
            maxLength={255}
            placeholder="Descreva onde estão as chaves"
          />
        </div>
      ) : null}
      {showPassword ? (
        <KeyLocationPasswordField
          value={keyLocationPassword}
          onChange={onKeyLocationPasswordChange}
          error={passwordError}
          required={!allowBlankPassword}
          hint={
            allowBlankPassword
              ? "Deixe em branco para manter a senha atual."
              : undefined
          }
        />
      ) : null}
    </div>
  );
}
